import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
const Container = styled.div.withConfig({
  displayName: "SelectionComponentAnimationState__Container",
  componentId: "sc-5ncsam-0"
})(["display:flex;flex-direction:row;"]);
export const SelectionComponentAnimationState = observer(({
  onAnimationStateChange,
  store,
  buttonType: Button = "div"
}) => {
  var _store$selectedAnimat, _store$selectedAnimat2, _store$selectedAnimat3;

  return /*#__PURE__*/React.createElement(Container, null, (_store$selectedAnimat = store.selectedAnimation) === null || _store$selectedAnimat === void 0 ? void 0 : (_store$selectedAnimat2 = _store$selectedAnimat.spine) === null || _store$selectedAnimat2 === void 0 ? void 0 : (_store$selectedAnimat3 = _store$selectedAnimat2.spineData) === null || _store$selectedAnimat3 === void 0 ? void 0 : _store$selectedAnimat3.animations.map(animationState => /*#__PURE__*/React.createElement(Button, {
    className: store.selectedAnimationState == animationState.name ? "selected" : "",
    key: animationState.name,
    onClick: () => {
      onAnimationStateChange(animationState.name);
    }
  }, " ", animationState.name)));
});